import { render, staticRenderFns } from "./emptyCart.vue?vue&type=template&id=6d93d5f6&scoped=true&"
import script from "./emptyCart.vue?vue&type=script&lang=js&"
export * from "./emptyCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d93d5f6",
  null
  
)

export default component.exports